/**
 *
 * Campaigns/Form/Disclaimer
 *
 */

import React, { useMemo, useState } from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState, ContentState, convertFromRaw } from 'draft-js'

import { defaultWrapperStyle, defaultEditorStyle, defaultToolbarStyle } from 'components/TextEditor'

function Disclaimer({ disclaimer_json, onChange, disabled }) {
	const initialEditorState = useMemo(() => {
		let disclaimer = disclaimer_json

		if (disclaimer === null || (typeof disclaimer === 'object' && !Object.keys(disclaimer).length)) {
			disclaimer = ''
		}

		let content_state
		switch (typeof disclaimer) {
			case 'undefined':
				content_state = ContentState.createFromText('')
				break
			case 'string':
				content_state = ContentState.createFromText(disclaimer)
				break
			default:
				content_state = convertFromRaw(disclaimer)
				break
		}

		return EditorState.createWithContent(content_state)
	}, [])

	const [editorState, setEditorState] = useState(initialEditorState)

	const onEditorStateChange = (newEditorState) => {
		setEditorState(newEditorState)
		onChange(newEditorState.getCurrentContent())
	}

	return (
		<div className="p-relative mt-3">
			<Editor
				editorState={editorState}
				onEditorStateChange={onEditorStateChange}
				wrapperStyle={{ ...defaultWrapperStyle, height: 450, marginBottom: '1rem', background: '#fff' }}
				editorStyle={{ ...defaultEditorStyle, position: 'relative', zIndex: 99, height: 'calc(100% - 160px)' }}
				toolbarStyle={defaultToolbarStyle}
				toolbarHidden={disabled} // Hides the entire toolbar
			/>
		</div>
	)
}

Disclaimer.propTypes = {
	disclaimer_json: PropTypes.array,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
}

export default Disclaimer
